import { Link, useNavigate } from "react-router-dom";
import Layout from "../include/layout";
import { myroutes } from "../../routes/webroute";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import $ from "jquery"

import Select from 'react-select';
import makeAnimated from 'react-select/animated';

import { useSelector } from "react-redux";
import TarificationsService from "../../services/TarificationsService";
import PeriodiquesService from "../../services/PeriodiquesService";
import PeriodicitesService from "../../services/PeriodicitesService";

export default function CreateTarifications() {

    //##########################/// METHODES ##########################///
    //navigate pour faire les redirections
    const navigate = useNavigate()
    const [validationError, setValidationError] = useState({})

    //Creation des ascesseurs getters et setters pour tout le formulaire
    const [libelle, setLibelle] = useState('')
    const [nbr_media, setNbrMedia] = useState('')
    const [tarif, setTarif] = useState('')
    const [nbr_acces, setNbrAcces] = useState('')
    const [periodicites, setPeriodicites] = useState([])
    const [periodicite_id, setPeriodiciteId] = useState('')

    const [periodiques, setPeriodiques] = useState([])
    const [periodique_id, setPeriodiqueId] = useState('')

    const [validite, setValidite] = useState('')

    const animatedComponents = makeAnimated();

    const token = useSelector(state => state.auth.token)

    //get periodique
    const fetchPeriodiques = async () => {
        await PeriodiquesService.index().then((response) => {
            setPeriodiques(response.data.liste_periodiques.map((option) => ({
                value: option.id,
                label: option.titre_periodicite
            })))
        }).catch(error => {
            console.log(error)
        })
    }

    //get value selected
    const handlePeriodiqueSelection = (selectedOptions) => {
        setPeriodiqueId(selectedOptions);
    };

    //get periodicite
    const fetchPeriodicites = async () => {
        await PeriodicitesService.index(token).then((res) => {
            setPeriodicites(res.data.liste_periodicites)
        }).catch(error => {
            console.log(error)
        })
    }

    ///Save form data
    const handleSubmit = async (event) => {
        event.preventDefault()
        //Recupérer uniquement les id
         //var periodique = periodique_id.map((option) => option.value)

        let form = {
            libelle, nbr_media, tarif, nbr_acces, periodicite_id, validite, periodique_id,
        }

        await TarificationsService.store(form, token).then((response) => {
            console.log(response)
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur,
                    showConfirmButton: false,
                    timer: 2000
                })
                setValidationError(response.data.erreur)
            } else {
                //redirection sur index
                navigate(myroutes.users_index)
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            setValidationError(error.message)
        });
    }


    useEffect(() => {
        fetchPeriodiques()
        fetchPeriodicites()
        $("#submenu-3").addClass("show")
    }, [])
    //##########################/// END METHODES ##########################///

    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0 text-start">Administration</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item"><Link to={myroutes.tarifications_index} >Tarifications</Link></li>
                                        <li className="breadcrumb-item active">Nouvelle tarifications </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Enregistrement </h1>
                        </div>
                    </div>{/*//row*/}

                    <div className="app-card app-card-settings shadow-lg mb-5">
                        <div className="app-card-body py-3">
                            <Row>
                                {
                                    Object.keys(validationError).length > 0 && (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="alert alert-danger">
                                                    <ul className="mb-0">
                                                        {
                                                            <li>{validationError}</li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </Row>
                            <Form className="mx-3 settings-form" style={{ textAlign: "left" }} onSubmit={handleSubmit}>

                                <Row>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Libelle <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setLibelle(e.target.value)}
                                                value={libelle}
                                                placeholder="Le libelle"
                                                name="libelle"
                                                aria-label="libelle"
                                                maxLength={200}
                                                minLength={3}
                                                type="text"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nbre média <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setNbrMedia(e.target.value)}
                                                value={nbr_media}
                                                name="nbr_media"
                                                aria-label="nbr_media"
                                                type="number"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Validité publication (en jour) <i className="text-danger">*</i>
                                            </Form.Label>
                                            <select name="validite" value={validite} id="validite" className="border border-info border rounded-2 form-control form-select bg-white" onChange={(e) => setValidite(e.target.value)}>
                                                <optgroup label="Liste disponible">
                                                    <option value="30" selected>30</option>
                                                    <option value="90">90</option>
                                                    <option value="365">365</option>
                                                </optgroup>
                                            </select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3 flex justify-content-center">
                                            <Form.Label>Périodiques <i className="text-danger">*</i> </Form.Label>
                                            <Select
                                                options={periodiques}
                                                onChange={handlePeriodiqueSelection}
                                                value={periodique_id}
                                                components={animatedComponents}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tarif <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setTarif(e.target.value)}
                                                value={tarif}
                                                name="tarif"
                                                aria-label="tarif"
                                                type="number"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nbre Accès <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setNbrAcces(e.target.value)}
                                                value={nbr_acces}
                                                name="nbr_acces"
                                                aria-label="nbr_acces"
                                                type="number"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Périodicité <i className="text-danger">*</i>
                                            </Form.Label>
                                            <select name="periodicites" value={periodicite_id} id="periodicites" className="border border-info border rounded-2 form-control form-select bg-white" onChange={(e) => setPeriodiciteId(e.target.value)}>
                                            <option value="" selected disabled>Sélectionnez une valeur</option>
                                                {periodicites.map((item, i) => (
                                                    <option value={item.id} key={i}>{item.libelle}</option>
                                                ))}
                                            </select>
                                        </Form.Group>
                                    </Col>

                                    
                                </Row>

                                <Button type="submit" variant="primary">Enregistrer</Button>
                            </Form>

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}